import React from 'react';
import ScreenComponent from "../../components/screenComponent";
import DivTable from "../../components/divTable";
import {Get, Post} from "../../components/request";
import screens from "../../screens";
import {withRouter} from "react-router-dom";
import MySelect from "../../components/form/mySelect";
import {Alert, Button} from "react-bootstrap";

class TP extends ScreenComponent {
    constructor(props) {
        super(props);
        this.state = {
            cours: [],
            current: [],
            item: 0,
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        const {body} = await Get(`/v1/extranet/student/${screens.InscriptionTP}`);

        body.map((b) => {
            b.GroupeActiviteApprentissagePlageHoraire = null;
            b.options = [];
        });

        this.setState({
            cours: body
        });
    }

    async save() {
        if (this.state.item < this.state.cours.length) {
            var current = this.state.cours[this.state.item];
            var {body} = await Get(`/v1/extranet/student/${screens.InscriptionTP}01/${current.ActiviteApprentissageID}`);

            let options = [];
            body.Values.map((v) => options.push({
                value: Number(v.ID),
                label: v.Display.substr(0, 1) === "#" ? v.Display.substr(3, v.Display.length - 3) : v.Display,
                display: v.Display,
                isDisabled: v.Disabled
            }));

            current.options = options;

            this.setState({
                item: this.state.item + 1,
                current: [current]
            }, () => {
                this.state.current.forEach(async (c) => {
                    c.ref.select.clearValue();
                })
            })
        } else {
            this.state.cours.forEach((c) => {
                if (c.ref !== null && c.ref !== undefined) {
                    delete c.ref;
                }
            })

            await Post(`/v1/extranet/student/inscriptionTP`, this.state.cours, "Sauvegarde en cours..", {render: "Inscription sauvegardée, pour autant que vos choix de places étaient encore disponibles au moment de votre enregistrement !"}, {render: "Erreur lors de la sauvegarde"});

            this.props.history.push(process.env.APP_ROOT + 'desktop');
        }
    }

    update(elm, select) {
        elm.GroupeActiviteApprentissageID = select?.value ?? null;
        elm.GroupeActiviteApprentissagePlageHoraire = select?.display ?? null
    }

    getAlert() {
        return this.state.item !== 0 ? (<>
            {this.state.cours.length - this.state.item > 0 &&
            <Alert variant={"info"}>
                Il vous
                reste <b>{this.state.cours.length - this.state.item} inscription{this.state.cours.length - this.state.item > 1 && "s"}</b> à
                effectuer/vérifier
            </Alert>
            }
        </>) : (<><Alert variant={"info"}>
            Afin de finaliser votre horaire, merci de bien vouloir vous inscrire dans un TP pour chacun des cours qui
            vont vous être affichés à l'écran</Alert>
            <Alert variant={"danger"}>
                Il est nécessaire d'aller au bout de la procédure afin que vos choix soient sauvegardés.<br/> Si aucune
                inscription n'est possible, notez le(s) cours concerné(s), prenez contact avec votre coordinateur
                d'année et poursuivez la procédure à l'écran.</Alert></>);
    }

    render() {
        return (
            <>
                <section>
                    {this.getAlert()}
                    {this.state.item !== 0 && <DivTable
                        columns={{
                            "Code": "ActiviteApprentissageCode",
                            "Intitulé": "ActiviteApprentissageLibelle",
                            "Groupes": (item) => {
                                return (
                                    <div className="p-3 text-left" style={{minWidth: "200px"}}>
                                        <MySelect ref={(r) => item.ref = r}
                                                  onChange={this.update.bind(this, item)}
                                                  options={item.options}
                                                  value={item.options.find(f => f.value === item.GroupeActiviteApprentissageID)}
                                                  isClearable={true}
                                                  isDisabled={item.GroupeActiviteApprentissageID !== null}
                                        />
                                        {item.GroupeActiviteApprentissageID !== null && <small>
                                            Déjà choisi (cf. votre PAE dans l'AA correspondante)
                                        </small>}
                                    </div>
                                );
                            }
                        }}
                        array={this.state.current}
                    />}
                    <Button onClick={this.save.bind(this)} className={"my-5"} size="lg"
                            variant={this.state.item === 0 ? "dark" : (this.state.item === this.state.cours.length ? "success" : "primary")}
                            block>{this.state.item === 0 ? "Démarrer mon inscription" : (this.state.item === this.state.cours.length ? "Sauvegarder" : "Inscription suivante >")} </Button>
                </section>
            </>
        );
    }
}

export default withRouter(TP);